import { useNavigate, useLocation } from "react-router-dom";
import { FaArrowLeft } from "react-icons/fa";

function BotonVolver({ fallback = "/", stateToReturn = null }) {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname;
  const pathSegments = currentPath.split("/").filter(Boolean);

  const autoFallback =
    pathSegments.length > 1 ? `/${pathSegments.slice(0, -1).join("/")}` : "/";

  const destino = fallback || autoFallback;

  const handleVolver = () => {
    navigate(destino, { state: stateToReturn });
  };

  return (
    <button
      onClick={handleVolver}
      className="bg-transparent border-0 p-0 d-flex align-items-center fw-medium gap-2 mb-2"
      style={{ cursor: "pointer", color: "var(--color-text)" }}
    >
      <FaArrowLeft />
      <span>Volver</span>
    </button>
  );
}

export default BotonVolver;
